import { FaPlus, FaMinus, FaSortDown } from 'react-icons/fa';
import { TbLockFilled } from 'react-icons/tb';
import { IoGameController } from 'react-icons/io5';
import { AiOutlinePlusSquare, AiOutlineMinusSquare } from 'react-icons/ai';
import { BiChevronRight } from 'react-icons/bi';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { FaHome } from 'react-icons/fa';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa';
import { FaPrint } from 'react-icons/fa';
import { MdCheckCircle, MdInfo, MdWarning } from 'react-icons/md';
import { RiCloseCircleFill } from 'react-icons/ri';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { IoMdArrowDropright } from 'react-icons/io';
import { RiInformation2Fill } from 'react-icons/ri';
import { GiCricketBat } from 'react-icons/gi';
import { MdSportsCricket } from 'react-icons/md';
export const Icons = {
  solidDown: FaSortDown,
  lock: TbLockFilled,
  gameController: IoGameController,
  outlinePlus: AiOutlinePlusSquare,
  outlineMinus: AiOutlineMinusSquare,
  angularRightArrow: BiChevronRight,
  plusBold: FaPlus,
  minusBold: FaMinus,
  plus: FiPlus,
  minus: FiMinus,
  home: FaHome,
  openEye: FaEye,
  closeEye: FaEyeSlash,
  download: FaDownload,
  print: FaPrint,
  loading: AiOutlineLoading3Quarters,
  dropArrowRight: IoMdArrowDropright,
  info: RiInformation2Fill,
  bet: GiCricketBat,
  ball: MdSportsCricket,
  // toast icons
  toastSuccess: MdCheckCircle,
  toastError: RiCloseCircleFill,
  toastInfo: MdInfo,
  toastWarning: MdWarning,
};
